import React from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from 'services/toasts';
import { Modal, ModalFooter, Loading } from '@carbon/react';
import { useDeleteStreamMutation } from 'services/stream';

//TODO: integrate context for sideforms
const DeleteStreamModal = ({ stream,cb = () => {},  hideModal }) => {

  const dispatch = useDispatch();
  const [deleteStream, {isLoading}] = useDeleteStreamMutation();

  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText="Löschen"
      secondaryButtonText="Abbrechen"
      modalHeading="Soll der Stream wirklich gelöscht werden?"
      onRequestClose={hideModal}
      onRequestSubmit={async () => {
        try {
          await deleteStream(stream.model.ID);
        } catch {
          dispatch(
            showToast({
              kind: 'error',
              title: 'Fehler',
              caption: 'Der Stream konnte nicht gelöscht werden',
            })
          );
        } finally {
          cb();
          hideModal();
          dispatch(showToast({
            kind: 'success',
            title: 'Stream gelöscht',
            caption: 'Der Stream wurde erfolgreich gelöscht',
          }));
        }
      }}>
      {(stream.devices || []).length > 0 && (
        <>
          <p>Dieser Stream ist mit micast Systeme verknüpft.</p>
          <p>
            Ein löschen führt dazu das auf den Geräten keine Elemente mehr
            angezeigt werden!
          </p>
          <ModalFooter></ModalFooter>
        </>
      )}
      <Loading active={isLoading} withOverlay={true} />
    </Modal>
  );
};

export default DeleteStreamModal;
